module.exports = __webpack_public_path__ + "a88eb08033c05c9055d8e0fbdc16a730.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf
// module id = 1059
// module chunks = 1